var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyCultureBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.73 43.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.12,21.99c5.32-4.28,6.15-12.06,1.87-17.38S15.92-1.55,10.61,2.74c-5.32,4.28-6.15,12.06-1.87,17.38.55.69,1.18,1.32,1.87,1.87C4.18,24.74,0,31.05,0,38.05v3.56c0,1.15.93,2.08,2.08,2.08h32.57c1.15,0,2.08-.93,2.08-2.08v-3.56c0-6.99-4.18-13.31-10.61-16.06Zm-7.75-17.81c4.53,0,8.2,3.67,8.2,8.2s-3.67,8.2-8.2,8.2-8.2-3.67-8.2-8.2c0-4.53,3.68-8.2,8.2-8.2Zm14.21,35.35H4.16v-1.48c0-7.35,5.96-13.3,13.31-13.31h1.79c7.35,0,13.3,5.96,13.31,13.31v1.48Z",
    fill: "#fff",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyCultureBad);
export default __webpack_public_path__ + "static/media/company_culture_bad.3bb7cca56bf6f4646988ca35a44d5229.svg";
export { ForwardRef as ReactComponent };